import { render } from "./HeroiconsSolidChartBar.vue?vue&type=template&id=67b64dab"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidChartBar.vue"]])

export default __exports__